import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchPlaceDetails } from '../api';

const PlaceDetails = () => {
    const { id } = useParams();
    const [place, setPlace] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadPlaceDetails();
    }, [id]);

    const loadPlaceDetails = async () => {
        try {
            setLoading(true);
            const response = await fetchPlaceDetails(id);
            setPlace(response.data);
        } catch (err) {
            setError('Ошибка при загрузке данных');
            console.error('Error loading place details:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading">Загрузка...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <div className="error">{error}</div>
            </div>
        );
    }

    if (!place) {
        return (
            <div className="error-container">
                <div className="error">Место не найдено</div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="place-details">
                <div className="place-header">
                    <h1>{place.name}</h1>
                    <div className="place-meta">
                        <Link to={`/region/${place.region_id}`} className="place-region">
                            <span className="icon">📍</span>
                            {place.region_name}
                        </Link>
                        <span className="place-type">
                            <span className="icon">📁</span>
                            {place.type_name}
                        </span>
                    </div>
                </div>

                {place.image_url && (
                    <div className="place-image">
                        <img src={place.image_url} alt={place.name} />
                    </div>
                )}

                <div className="place-content">
                    <div className="place-description">
                        <h2>Описание</h2>
                        <p>{place.description}</p>
                    </div>

                    {place.history && (
                        <div className="place-history">
                            <h2>История</h2>
                            <p>{place.history}</p>
                        </div>
                    )}

                    {place.how_to_get && (
                        <div className="place-how-to-get">
                            <h2>Как добраться</h2>
                            <p>{place.how_to_get}</p>
                        </div>
                    )}

                    {place.working_hours && (
                        <div className="place-working-hours">
                            <h2>Режим работы</h2>
                            <p>{place.working_hours}</p>
                        </div>
                    )}

                    {place.contacts && (
                        <div className="place-contacts">
                            <h2>Контакты</h2>
                            <p>{place.contacts}</p>
                        </div>
                    )}

                    {place.additional_info && (
                        <div className="place-additional-info">
                            <h2>Дополнительная информация</h2>
                            <p>{place.additional_info}</p>
                        </div>
                    )}
                </div>

                <div className="place-actions">
                    <Link to="/" className="btn btn-outline">
                        ← Назад к списку
                    </Link>
                    <Link to={`/region/${place.region_id}`} className="btn btn-primary">
                        Смотреть другие места в регионе
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PlaceDetails;